import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { ProfileService } from 'src/app/services/profile.service';
import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-amcmastertransaction',
  templateUrl: './amcmastertransaction.component.html',
  styleUrls: ['./amcmastertransaction.component.scss']
})
export class AmcmastertransactionComponent implements OnInit {
  AmcMAsterArr: any = [];
  AMCString: any = '';
  TempAmcMAsterArr: any = [];
  Subbrokercode: any;
  SelectALL: boolean = false;

  constructor(
    private profileService: ProfileService,
    private EncrdecrService: EncrdecrService
  ) {}
  ngOnInit() {
    if (
      sessionStorage.getItem('F44sGAGh2xwkpUL') != null &&
      sessionStorage.getItem('F44sGAGh2xwkpUL') != undefined
    ) {
      this.Subbrokercode = this.EncrdecrService.getDecr(
        sessionStorage.getItem('F44sGAGh2xwkpUL')
      );
    }
    this.BindUpdateList('GET');
  }
  BindUpdateList(Flag: any) {
    let request = {
      SubBrokerCode: this.Subbrokercode,
      Flag: Flag,
      AMCCode: this.AMCString != '' ? this.AMCString : ''
    };
    this.profileService.SubbrokerAmcList(request).subscribe((res: any) => {
      if (res.ArrayOfResponse.length > 0) {
        let AmcdetailsArr = res.ArrayOfResponse;
        this.TempAmcMAsterArr = AmcdetailsArr;
        this.Active_InActivestatus('000000');
        this.AmcMAsterArr = this.TempAmcMAsterArr;
        if (Flag == 'InsertUpdate') {
          this.CallAlertModal('Saved Successfully');
        }
      } else {
        this.CallAlertModal('No Data found');
      }
    });
  }
  Active_InActivestatus(AMCCode: any) {
    debugger;
    let AMCStrings = [];
    if (AMCCode != '' && AMCCode != null) {
      this.TempAmcMAsterArr.map((arr: any, index: number) => {
        if (arr.AMCCode == AMCCode) {
          arr.status = arr.status == 0 ? 1 : 0;
        }
        if (arr.status == 1) {
          AMCStrings.push(arr.AMCCode);
        }
      });
      this.AMCString = AMCStrings.join(',');
      this.AmcMAsterArr = this.TempAmcMAsterArr;
    }

    console.log('this.AMCString', this.AMCString);
  }
  CallAlertModal(msg: any) {
    $('#AlertModal').modal({
      backdrop: 'static',
      keyboard: false
    });
    $('#AlertModalContent').text(msg);
  }

  OnSubmit() {
    if (this.AMCString.length > 0 && this.AMCString != '') {
      this.BindUpdateList('InsertUpdate');
    } else {
      return this.CallAlertModal('Please Select AMC');
    }
  }

  SelectDeselect() {
    debugger;
    this.SelectALL = !this.SelectALL;
    let AMCStrings = [];

    this.TempAmcMAsterArr.map((arr: any, index: number) => {
      if (this.SelectALL == true) {
        arr.status = 1;
      } else {
        arr.status = 0;
      }
      if (arr.status == 1) {
        AMCStrings.push(arr.AMCCode);
      }
    });
    this.AMCString = AMCStrings.join(',');
    this.AmcMAsterArr = this.TempAmcMAsterArr;

    console.log('this.AMCString', this.AMCString);
  }
  dummydata() {
    const AmcdetailsArr = [
      {
        status: 1,
        AMCName: 'ABC',
        AMCCode: 4001
      },
      {
        status: 1,
        AMCName: 'BCD',
        AMCCode: 4002
      },
      {
        status: 1,
        AMCName: 'CDE',
        AMCCode: 4003
      },
      {
        status: 1,
        AMCName: 'DEF',
        AMCCode: 4004
      },
      {
        status: 1,
        AMCName: 'EFG',
        AMCCode: 4005
      },
      {
        status: 1,
        AMCName: 'FGH',
        AMCCode: 4006
      }
    ];
    this.TempAmcMAsterArr = AmcdetailsArr;
    this.AmcMAsterArr = this.TempAmcMAsterArr;
  }
}
